import { CheckCircleIcon } from '@chakra-ui/icons';

import { RelevoInterface } from '../../../../api/types';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { ScanItemInfo } from '../components/ScanItemInfo';
import { ScanStateLayout } from '../components/ScanStateLayout';

type SuccessStateProps = {
  onAnimationComplete: () => void;
  item?: RelevoInterface;
  progressResetKey?: string | number;
};

export const SuccessState = ({ item, onAnimationComplete, progressResetKey }: SuccessStateProps) => {
  const translations = useTranslations();

  const imageSrc = item?.category.imageUrl || undefined;

  return (
    <ScanStateLayout
      headingIcon={<CheckCircleIcon color={'green.800'} w={5} h={5} />}
      heading={translations('scan_modal_success_heading')}
      imageSrc={imageSrc}
      onAnimationComplete={onAnimationComplete}
      progressResetKey={progressResetKey}
    >
      {item ? <ScanItemInfo item={item} /> : null}
    </ScanStateLayout>
  );
};
